// stores/useSalesPlatformStore.js
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { salesPlatformApi } from '@/api'

export const useSalesPlatformStore = defineStore('salesPlatform', () => {
  const platforms = ref([])
  const loading = ref(false)
  let loadPromise = null  // ✅ 防重复请求

  async function loadPlatforms(force = false) {
    // 如果已有数据且不强制刷新，直接返回
    if (!force && platforms.value.length > 0) {
      return platforms.value
    }

    // 如果正在请求中，返回同一个 Promise
    if (loadPromise) {
      return loadPromise
    }

    loadPromise = (async () => {
      loading.value = true
      try {
        const data = await salesPlatformApi.getList()
        if (data && data.success) {
          platforms.value = data.data || []
          return platforms.value
        }
        return []
      } catch (err) {
        console.error('加载销售平台失败:', err)
        return []
      } finally {
        loading.value = false
        loadPromise = null
      }
    })()

    return loadPromise
  }

  async function createPlatform(data) {
    const result = await salesPlatformApi.create(data)
    if (result && result.success) {
      await loadPlatforms(true)  // 强制刷新
      return result.data
    }
    return null
  }

  async function updatePlatform(data) {
    const result = await salesPlatformApi.update(data)
    if (result && result.success) {
      await loadPlatforms(true)
      return result.data
    }
    return null
  }

  async function deletePlatform(id) {
    const result = await salesPlatformApi.delete(id)
    if (result && result.success) {
      await loadPlatforms(true)
      return true
    }
    return false
  }
  // ===== 根据名称查找默认平台ID =====
  function getIdByName(name) {
    const platform = platforms.value.find(p => p.name === name)
    return platform ? platform.id : null
  }

  return {
    platforms,
    getIdByName,
    loading,
    loadPlatforms,
    createPlatform,
    updatePlatform,
    deletePlatform
  }
})